import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@/shared/i18n/i18n";
import { store } from "@/app/store";
import { fetchTenantConfiguration } from "@/features/app-config/model/tenantConfigurationSlice";
import { isSharedAppPath } from "@/features/shared-apps/lib/sharedAppRoute";
import { AppProviders } from "@/app/providers/AppProviders";
import { App } from "@/app/App";
import {
  applyCssVariables,
  getThemeConfig,
  readStoredAppearancePreference,
} from "@/config/themes";
import { bootstrapAuthSession } from "@/shared/auth/cognito";
import { logDevEnvSanity } from "@/shared/config/logDevEnvSanity";
import "@/app/styles/global.css";

logDevEnvSanity();
applyCssVariables(getThemeConfig(readStoredAppearancePreference()));
bootstrapAuthSession();

// The tenant configuration payload is Cognito identifiers only, which the public shared-app page
// never uses. Read `window.location` directly: this runs before React and the router exist.
if (!isSharedAppPath(window.location.pathname)) {
  void store.dispatch(fetchTenantConfiguration());
}

const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error('Missing root element with id "root".');
}

createRoot(rootEl).render(
  <StrictMode>
    <AppProviders>
      <App />
    </AppProviders>
  </StrictMode>
);
